export default __webpack_public_path__ + "static/media/me-atualizado-com-fundo.41d625fe.jpeg";